import { EnvConfig } from '../../config/EnvConfig'
import { GamesLanguages } from '../constants'
import { getWebsiteUrl } from '../getWebsiteUrl'
import { generateURL } from './generateURL'

const locale = process.env.GATSBY_INTL_LOCALE
const language = GamesLanguages?.['*:*']?.[locale]
const env = process.env.GATSBY_ENV
const websiteURL = getWebsiteUrl()

export const setPlaytechURL = ({
  providerData,
  isMobile,
  casinoSlug,
  mobileSlug,
  desktopSlug,
  depositUrl,
  user,
  isMock,
}) => {
  const playMode = isMock || !user
  const isStaging = env === 'dev' || env === 'stage' || env === 'local' || env === 'develop'
  const funMode = user ? 2 : 0
  const username = user ? user.id : 'test1'

  const getUserPrefix = () => {
    if (playMode) {
      return 'MOCK__'
    }

    if (isStaging) {
      return 'KTO__'
    }

    return ''
  }

  const options = [
    {
      param: 'username',
      value: `${getUserPrefix()}${username}`,
    },
    {
      param: 'casino',
      value: EnvConfig.PLAY_TECH_INSTANCE,
    },
    {
      param: 'clientPlatform',
      value: isMobile ? 'mobile' : 'web',
    },
    {
      param: 'externalToken',
      value: playMode ? null : providerData.token,
    },
    {
      param: 'language',
      value: language,
    },
    {
      param: 'playMode',
      value: playMode ? funMode : 1,
    },
    {
      param: 'lobbyUrl',
      value: `${websiteURL}${casinoSlug}`,
    },
    {
      param: 'depositUrl',
      value: depositUrl,
    },
    {
      param: 'integration',
      value: 'ucip',
    },
    {
      param: 'gameCodeName',
      value: isMobile ? mobileSlug : desktopSlug,
      disableEncode: true,
    },
  ]

  const baseURL = EnvConfig.PLAY_TECH_URL
  return generateURL({ baseURL, options })
}
